export default "__VITE_ASSET__2f589da0__"